import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import './plugins/vuejs-logger'
import App from './App.vue'
import {router} from './_helpers'
import {store} from './_store'
import './registerServiceWorker'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {VueReCaptcha} from 'vue-recaptcha-v3';
import "./stylus/main.styl"
// @modified daniel.silva 2019.07.05 not used at this moment
//import './plugins/vue2-google-maps'
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.use(Loading);

// @daniel.silva 2019.07.05 IMPORTANT!! set recaptcha api url
// TODO Review, only working in Firefox atm
var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
if (isFirefox) {
    window["__recaptcha_api"] = "https://www.recaptcha.net/recaptcha/";
}
//

Vue.use(VueReCaptcha, {
    siteKey: process.env.NODE_ENV === 'production' ? '6Ld29ZkUAAAAAJrisAhrp_q3fl-M2hehMMh-gqF7' : '6LeL9poUAAAAAGSsJ22QsL27yREFnXPx4lx5HAVn',
    loaderOptions: {
        useRecaptchaNet: true,
        autoHideBadge: true
    }
});

Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false;


new Vue({
    router,
    store,
    render: h => h(App),
    beforeCreate() { this.$store.commit('shop/initialiseStore');},
}).$mount('#app');